/* eslint-disable no-shadow */
import React from 'react'
import tw from 'twin.macro'

import { graphql } from 'gatsby'

import colors from '@/constants/colors'
import Quote, { QuoteProps } from '@/components/ui/quote'
import { extractDataAttributes } from '@/utils/dom'

export const fragment = graphql`
  fragment SectionMasonary on ContentfulSectionMasonary {
    __typename
    contentful_id
    backgroundColor
    cards {
      ... on ContentfulComponentQuote {
        ...Quote
      }
    }
  }
`

export interface SetOfMasonaryCardsProps {
  /** Cards - Cards added via contentful (atm just quote cards) */
  cards: QuoteProps[]
  /** Section background color */
  backgroundColor: string
}

/**
 * A Masonary style layout of cards
 *
 * Currently used to layout quotes for the media page https://bitwarden.com/media-spotlight/ <br />
 * Could be expanded in future for to include card components as well as quote components
 */

// eslint-disable-next-line react/function-component-definition
export const SetOfMasonaryCards = ({ backgroundColor, cards, ...rest }: SetOfMasonaryCardsProps) => {
  const dataAttributes = extractDataAttributes(rest)
  const { indigoBlue, primaryBlue, lightGray, white } = colors
  return (
    <section
      css={[
        (backgroundColor === white || backgroundColor === null) && tw`bg-white`,
        backgroundColor === primaryBlue && tw`bg-primaryBlue`,
        backgroundColor === lightGray && tw`bg-gray-100`,
        backgroundColor === indigoBlue && tw`bg-indigoBlue`,
      ]}
      {...dataAttributes}
    >
      <div tw="max-w-8xl mx-auto px-5 lg:px-9 py-10 lg:py-20">
        <div tw="columns-1 sm:columns-2 lg:columns-3 gap-8">
          {cards.map(({ contentful_id: id, attribution, body, citation, image, link, backgroundColor }) => (
            <div key={id} tw="mb-8 break-inside-avoid-column">
              <Quote
                attribution={attribution}
                backgroundColor={backgroundColor}
                body={body}
                citation={citation}
                image={image}
                link={link}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
